<template>
  <base-card>
    <template v-slot:header>
      <base-card-heading>{{ name }}</base-card-heading>

      <div v-if="hasShares()">
        {{ percentageShare }}%
      </div>
      <div v-else>
        <base-button small @click="remove">
          Remove
        </base-button>
      </div>
    </template>

    <div class="row mb-3">
      <div class="col-sm-6">
        <base-field label="Director">
          <base-select v-model="director" :options="directorsDropdown" placeholder="director" />
        </base-field>
      </div>
      <div class="col-sm-6">
        <base-field addon-right-icon="percent" label="Percentage Share">
          <base-input v-model="value.percentageShare" required type="number" />
        </base-field>
      </div>
    </div>
    <div v-if="!value.director">
      <user-details v-model="value" />
    </div>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

import UserDetails from './UserDetails.vue'

export default {
  created () {
    if (this.value.director) {
      this.director = this.value.director._id
    }
  },

  data () {
    return {
      director: null
    }
  },

  name: 'ShareholderEntry',

  components: {
    UserDetails
  },

  props: {
    value: { default: () => {}, type: Object }
  },

  computed: {
    directorsDropdown () {
      const dropdown = []

      if (this.$_.isArray(this.directors)) {
        this.directors.map(director => {
          if (this.$_.isObject(director)) {
            dropdown.push({
              text: `${director.profile.firstName} ${director.profile.lastName}`,
              value: director._id
            })
          }
        })
      }

      return dropdown
    },

    name () {
      const profile = this.selected ? this.selected.profile : this.value.profile

      if (!profile) return ''

      const { firstName, lastName } = profile

      return `${firstName} ${lastName}`
    },

    percentage () {
      return this.value.percentageShare || '0'
    },

    readonly () {
      const list = [
        'firstName',
        'middleName',
        'lastName',
        'email',
        'dob',
        'phone',
        'address'
      ]

      return this.director ? list : []
    },

    selected () {
      return this.directors.find(({ _id }) => _id === this.director)
    },

    ...mapState({
      directors: store => store.core.directors.rows
    })
  },

  methods: {
    hasShares () {
      return parseFloat(this.percentageShare) > 0.00
    },

    remove () {
      if (confirm('Are you sure you want to delete this shareholder?')) {
        this.$emit('remove', this.value)
      }
    }
  },

  watch: {
    director () {
      if (this.director !== '') {
        this.value.director = this.selected
      } else {
        this.value.director = null
      }
    }
  }
}
</script>
